module.exports = __webpack_public_path__ + "assets/69cdf7ad616332d3d4657e6e8f74fbac.png";